import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';
import { useIsLicensed } from '@confluence/session-data';

import { isWithinLastWeek } from '../utils/isWithinLastWeek';

export const useShouldShowNewUserTemplates = () => {
	const isLicensed = useIsLicensed();

	const { data, loading, error } = useGetOnboardingState(
		[...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		!isLicensed || !fg('land_users_in_editor_with_revamped_bpqa'),
	);
	const { revampedBpqaShownAt } = deserializeState(data);
	const shownAtWithinLastWeek = isWithinLastWeek(revampedBpqaShownAt);

	if (!isLicensed || !fg('land_users_in_editor_with_revamped_bpqa')) {
		return { showNewUserTemplates: false, loading: false };
	}

	if (loading) {
		return { showNewUserTemplates: false, loading: true };
	}

	if (error) {
		return { showNewUserTemplates: false, loading: false, error };
	}

	return {
		showNewUserTemplates:
			shownAtWithinLastWeek &&
			(expValEquals('land_users_in_editor_with_revamped_bpqa_new', 'cohort', 'experiment') ||
				expValEquals('land_users_in_editor_with_revamped_bpqa_existing', 'cohort', 'experiment')),
		loading: false,
	};
};
